export const BILL_SCOPE_NAMES = {
  organization: 'organization',
  active: 'active',
  energyStar: 'energyStar',
  find: 'find',
  full: 'full',
  minimal: 'minimal',
  table: 'table',
};
